export default __webpack_public_path__ + "static/The Home_Image 6_carousel 1@2x-f3b9c29895293c2499b480235600ba33.jpg";